'use strict';

const Moment = require('moment');
const SVGNodeView = require('common/ui/view/svg/node');
const SVGCollectionView = require('common/ui/view/svg/collection');

const DateView = SVGNodeView.extend({
    className: 'date',
    shapeViewClass: 'circle',
    shapeViewOptions: {r: 0},

    locator: function() {
        const scale = this.getOption('scale');
        const date = this.model.get('date');

        return {
            x: scale.locateX(date),
            y: 0
        }
    },

    onRender: function() {
        DateView.__super__.onRender.call(this);

        const scale = this.getOption('scale');
        const rootDateTime = scale.getRootDateTime();
        const date = this.model.get('date');
        const today = Moment(0, 'HH');

        if(date.isSame(today)) {
            this.renderToday();
        } else if(date.isSame(rootDateTime) || date.date() == 1) {
            this.renderHeading();
        } else {
            this.renderSubheading();
        }

        this.renderDayOfWeek();
        this.renderLine();
    },

    renderToday: function() {
        this.renderHeading();

        const scale = this.getOption('scale');
        const date = this.model.get('date');
        const width = scale.locateX(date.clone().add(1, 'day')) - scale.locateX(date);

        this.$el.append('rect')
            .classed('gantt-today', true)
            .attr('width', width)
            .attr('height', 10000)
            .attr('x', 0)
            .attr('y', 54);
    },

    renderHeading: function() {
        const scale = this.getOption('scale');
        const date = this.model.get('date');
        const x = scale.locateX(date.clone().add(12, 'hours')) - scale.locateX(date);

        this.$el.append('text')
            .text(date.format('MMM'))
            .style('font-size', 14)
            .style('fill', '#424242')
            .attr('x', x)
            .attr('y', 14)
            .style('text-anchor', 'middle');

        this.$el.append('text')
            .text(date.format('D'))
            .style('font-size', 14)
            .style('fill', '#424242')
            .attr('x', x)
            .attr('y', 32)
            .style('text-anchor', 'middle');
    },

    renderSubheading: function() {
        const scale = this.getOption('scale');
        const date = this.model.get('date');
        const x = scale.locateX(date.clone().add(12, 'hours')) - scale.locateX(date);

        this.$el.append('text')
            .text(date.format('D'))
            .style('font-size', 12)
            .style('fill', '#424242')
            .attr('x', x)
            .attr('y', 32)
            .style('text-anchor', 'middle');
    },

    renderDayOfWeek: function() {
        const scale = this.getOption('scale');
        const date = this.model.get('date');
        const x = scale.locateX(date.clone().add(12, 'hours')) - scale.locateX(date);

        const dayOfWeek = this.$el.append('text')
            .text(date.format('ddd'))
            .style('font-size', 12)
            .style('fill', '#424242')
            .attr('x', x)
            .attr('y', 48)
            .style('text-anchor', 'middle');

        if(date.day() == 0) {
            dayOfWeek.style('fill', 'red');
        } else if(date.day() == 6) {
            dayOfWeek.style('fill', 'blue');
        }
    },

    renderLine: function() {
        this.$el.append('line')
            .attr('x1', 0)
            .attr('y1', 54)
            .attr('x2', 0)
            .attr('y2', 10000)
            .style('stroke-width', 1)
            .style('stroke', '#ccc');
    }
});

module.exports = SVGCollectionView.extend({
    className: 'date-scale',
    childView: DateView
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/gantt/date-axis.js